import { styled } from 'mz-ui-kit'

export const Content = styled('div', {
  minWidth: '490px',
  padding: '20px 40px',
})
